import React from 'react';
import { BookOpen, CheckCircle, Calculator, TrendingUp, Brain, ChevronRight } from 'lucide-react';

/**
 * LearnHub — Education & Guide Section (Light Mode Redesign)
 */
const LearnHub = ({ onNavigate }) => {
  const sections = [
    { id: 'guide', icon: BookOpen, title: 'Getting Started', desc: 'Complete setup guide and quiz', color: '#6366F1', progress: null },
    { id: 'checklist', icon: CheckCircle, title: 'Daily Checklist', desc: 'Pre-trade routine for consistency', color: '#10B981', progress: null },
    { id: 'tools', icon: Calculator, title: 'Trading Tools', desc: 'Risk calculator, pip value, compounding', color: '#F5A623', progress: null },
    { id: 'signals', icon: TrendingUp, title: 'How Signals Work', desc: 'Understanding AI signal generation', color: '#EF4444', progress: null },
    { id: 'risk', icon: Brain, title: 'Risk Management', desc: 'Position sizing and drawdown control', color: '#8B5CF6', progress: null },
  ];

  return (
    <div data-testid="learn-hub" style={{ fontFamily: 'Inter, sans-serif', maxWidth: '480px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0F172A', fontFamily: 'Poppins, sans-serif', marginBottom: '4px' }}>Learn</h1>
      <p style={{ fontSize: '13px', color: '#94A3B8', marginBottom: '20px' }}>Master trading with guided education</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {sections.map((s) => {
          const Icon = s.icon;
          return (
            <button
              key={s.id}
              data-testid={`learn-${s.id}`}
              onClick={() => onNavigate(s.id === 'guide' ? 'guide' : s.id === 'checklist' ? 'checklist' : s.id === 'tools' ? 'tools' : 'guide')}
              style={{
                display: 'flex', alignItems: 'center', gap: '14px', width: '100%',
                padding: '16px', background: '#FFF', borderRadius: '16px',
                border: '1px solid #E2E8F0', cursor: 'pointer', textAlign: 'left',
                transition: 'all 0.2s ease',
              }}
            >
              <div style={{
                width: '44px', height: '44px', borderRadius: '14px',
                background: `${s.color}10`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
              }}>
                <Icon size={22} color={s.color} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#0F172A', marginBottom: '2px' }}>{s.title}</div>
                <div style={{ fontSize: '12px', color: '#94A3B8' }}>{s.desc}</div>
              </div>
              <ChevronRight size={18} color="#CBD5E1" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LearnHub;
